import { CheckoutPayload } from "../../../core/models/checkout-payload.model";
import { CreditCardModel } from "../../../core/models/credit-card.model";
import { GlobalConfig } from "../../../core/models/global-config.model";
import { PaymentGatewayModel } from "../../../core/models/payment-gateway.model";
import DataService from "../../../core/services/data.service";

interface HexeaPayment {
  field(name: string, element: HTMLElement, options: any): any;
}

interface Hexea {
  paymentMethod(method: string): HexeaPayment;

  tokenize(paymentMethod: HexeaPayment, options: any): any;
}

declare global {
  var Hexea: (clientId: string) => Hexea;
}

export class CheckoutConnexPoint {
  private hexea?: Hexea;
  private hexeaPayment?: HexeaPayment;
  private hexeaToken?: any;
  
  constructor(
    private readonly global: GlobalConfig,
    private readonly isCardSwipeEnabled: KnockoutObservable<boolean>,
    private readonly name: KnockoutObservable<string>,
    private readonly postalCode: KnockoutObservable<string>,
    private readonly setErrorMessage: (error: string) => void,
    private readonly processPayment: (paymentType: string, data: Partial<CheckoutPayload>) => void,
    private readonly onCardBrandChange: (cardType: string, cardNumberId: string, cardBrandId: string, surchargeId: string) => void,
    private readonly dataService: DataService
  ) { }

  public async initialise(paymentGateway: PaymentGatewayModel) {
    await $.getScript(this.global.config.connexPointApiUrl);

    this.hexea = window.Hexea(paymentGateway.clientId);
    this.hexeaPayment = this.hexea.paymentMethod('card');

    if (this.isCardSwipeEnabled()) {
      this.initialiseCardSwipe()      
    } else {
      this.initialiseCardFields();
    }
  }

  public async purchase() {
    try {
        const result = this.hexeaToken ?? await this.hexea!.tokenize(this.hexeaPayment!, { nameOnCard: this.name(), isSaved: false, postalCode: this.postalCode() });

      if (result.error) {
        this.setErrorMessage(result.error.message);
      } else {
        const creditCard: CreditCardModel = {
            cardBrand: result.paymentMethod.brand,
            cardToken: result.paymentMethod.paymentMethodToken,
            cardCountry: result.paymentMethod.countryCode
        };
        this.processPayment(creditCard.cardBrand, { 
          creditCard,
          isCardSwipe: !!this.hexeaToken
        });
      }
    } catch (error) {
      this.setErrorMessage('An error occurred. Please try again.');
      this.dataService.LogJavascriptWarning(error instanceof Error 
          ? error
          : {
              name: `[UsbCardSwipe]`,
              message: `[UsbCardSwipe] purchase() error: ${JSON.stringify(error)}`
          });
    }
  }
  
  private initialiseCardSwipe() { 
    $('.connexpoint-card-swipe-elements').show();
    $('.connexpoint-elements').hide();

    const timerId = setInterval(() => {
      const iframesCardSwipe = document.querySelectorAll('iframe[name="hexeaSecureFrame2"]');
      const cardSwipeFrame = iframesCardSwipe.length > 0 ? iframesCardSwipe[0] : null;
      if (!cardSwipeFrame) return;
      $(cardSwipeFrame).css("height", "100px");
      $(cardSwipeFrame).focus();
    }, 500);

    const cardSwipeControl = document.getElementById('connexpoint-card-swipe')!;
    const cardSwipeDisplayError = document.getElementById('connexpoint-card-swipe-card-errors')!;

    const cardSwipeCardNumber = document.getElementById('connexpoint-card-swipe-card-number')!;
    const cardSwipeCardExpiry = document.getElementById('connexpoint-card-swipe-card-expiry')!;
    const maskChar = '\u2022'; // unicode Bullet char
    const cardNumberMask = `${maskChar.repeat(4)} ${maskChar.repeat(4)} ${maskChar.repeat(4)} ${maskChar.repeat(4)}`;
    const cardExpiryMask = `${maskChar.repeat(2)}/${maskChar.repeat(2)}`;

    const keyDownHandler = (event: any) => {
      const keyCodeBackSpace = 8;
      const keyCodeDelete = 46;
      const key = event.keyCode || event.charCode;
      const cardSwipeCardNumberValue = $(cardSwipeCardNumber).val();
      const cardSwipeCardExpiryValue = $(cardSwipeCardExpiry).val();
      const isValueMasked = cardSwipeCardNumberValue === cardNumberMask || cardSwipeCardExpiryValue === cardExpiryMask;
      const manualEntryCard = ((key == keyCodeBackSpace || key == keyCodeDelete) && isValueMasked)
          || !isValueMasked && ((!cardSwipeCardNumberValue || cardSwipeCardNumberValue.toString().length == 0)
              || (!cardSwipeCardExpiryValue || cardSwipeCardExpiryValue.toString().length == 0));

      if (manualEntryCard) {
          clearInterval(timerId);

          $(cardSwipeCardNumber).off();
          $(cardSwipeCardExpiry).off();
          $("#connexpoint-card-swipe-surcharge-info").hide();
          $("#connexpoint-surcharge-info").hide();

          this.hexeaToken = null;

          document.getElementById('connexpoint-card-number-label')!.textContent = 'MANUAL ENTRY - CREDIT CARD NUMBER';
          document.getElementById('connexpoint-card-expiry-label')!.textContent = 'MANUAL ENTRY - CREDIT CARD EXPIRY';

          this.hexeaPayment = this.hexea.paymentMethod('card');

          this.initialiseCardFields();
          return true;
      }
      event.preventDefault();
      return false;
    };

    $(cardSwipeCardNumber).on('keydown', keyDownHandler);
    $(cardSwipeCardExpiry).on('keydown', keyDownHandler);

    const styleCardSwipe = {
      base: {
        fontSize: '15px',
        color: 'white',
        backgroundColor: '#616C6B',
        height: '100px',
        width: '100%',
      },
      invalid: {
        backgroundColor: 'red',
      }
    };
    const cardSwipe = this.hexeaPayment?.field('cardSwipe', cardSwipeControl, { hideIcon: true, style: styleCardSwipe });

    cardSwipe.on('change', (event: any) => {
      clearInterval(timerId);
      if (event.error) {
        cardSwipeDisplayError.textContent = event.error.message;
        this.dataService.LogJavascriptWarning(event.error instanceof Error 
            ? event.error 
            : {
                name: `[UsbCardSwipe]`,
                message: `[UsbCardSwipe] ${JSON.stringify(event.error)}`
            });
      } else {
        cardSwipeDisplayError.textContent = '';
        if (event.complete === true) {
            this.hexea?.tokenize(this.hexeaPayment!, { nameOnCard: this.name, isSaved: false }).then((result: any) => {
              
              if (result.error) {
                this.hexeaToken = null;
                  cardSwipeDisplayError.textContent = result.error.message;
                  this.dataService.LogJavascriptWarning(result.error instanceof Error 
                      ? result.error 
                      : {
                          name: `[UsbCardSwipe]`,
                          message: `[UsbCardSwipe] ${JSON.stringify(result.error)}`
                      });
              } else {
                  this.hexeaToken = result;

                  $(".connexpoint-field-custom-input").css('font-size', '20px');
                  $(".connexpoint-card-swipe-field-container").css('bottom', '10px');
                  $(cardSwipeCardNumber).val(cardNumberMask);
                  $(cardSwipeCardExpiry).val(cardExpiryMask);

                  this.onCardBrandChange(result.paymentMethod.brand, '#connexpoint-card-swipe-card-number', '#connexpoint-card-swipe-card-brand', '#connexpoint-card-swipe-surcharge-info');
              }

            }, (error: any) => {
                this.hexeaToken = null;
                this.setErrorMessage('An error occurred. Please try again.');
                this.dataService.LogJavascriptWarning(error instanceof Error 
                    ? error 
                    : {
                        name: `[UsbCardSwipe]`,
                        message: `[UsbCardSwipe] ${JSON.stringify(error)}`
                    });
            });
        }
      }
    });
    cardSwipe.focus();
  }

  private initialiseCardFields() {
    $('.connexpoint-elements').show();
    $('.connexpoint-card-swipe-elements').hide();

    var cardNumberControl = document.getElementById('connexpoint-card-number')!;
    var cardExpirationControl = document.getElementById('connexpoint-card-expiry')!;

    const style = {
      base: {
        fontSize: '16px',
        color: "#32325D",
        '::placeholder': {
            color: '#DEDEDE'
        }
      }
    };
    var cardNumber = this.hexeaPayment!.field('cardNumber', cardNumberControl,
      {
        hideIcon: true,
        style: style,
        placeholder: 'XXXX XXXX XXXX XXXX'
      }
    );
    var cardExpiration = this.hexeaPayment!.field('cardExpiration', cardExpirationControl, { hideIcon: true, style: style });

    var cardNumberDisplayError = $('.connexpointcardnumber-error');

    cardNumber.on('change', (event: any) => {
      this.onCardBrandChange(event.brand, '#connexpoint-card-number', '#connexpoint-card-brand', '#connexpoint-surcharge-info');
    

        if (event.complete && !event.error) {
        } else {
            if (event.error) {
                cardNumberDisplayError.html(event.error.message);
                $('#connexpoint-card-number').addClass('connexpoint-field--invalid');
            } else {
                cardNumberDisplayError.html('');
                $('#connexpoint-card-number').removeClass('connexpoint-field--invalid ');
            }
        }

        if (event.error) {
            this.dataService.LogJavascriptWarning(event.error instanceof Error 
                ? event.error 
                : {
                    name: `[UsbCardSwipe]`,
                    message: `[UsbCardSwipe] card number change: ${JSON.stringify(event.error)}`
                });   
        }
    });
    var cardExpiryDisplayError = $('.connexpointcardexpiry-error');
    cardExpiration.on('change', (event: any) => {

        if (event.complete && !event.error) {

        } else {
            if (event.error) {
                cardExpiryDisplayError.html(event.error.message);
                $('#connexpoint-card-expiry').addClass('connexpoint-field--invalid');
            } else {
                cardExpiryDisplayError.html('');
                $('#connexpoint-card-expiry').removeClass('connexpoint-field--invalid');
            }
        }

        if (event.error) {
            this.dataService.LogJavascriptWarning(event.error instanceof Error 
                ? event.error 
                : {
                    name: `[UsbCardSwipe]`,
                    message: `[UsbCardSwipe] card expiration change: ${JSON.stringify(event.error)}`
                });   
        }
    });
  }
}

